function round(value, decimals = 2) {
	const newValue = Number(value);
	return newValue.toFixed(decimals);
}

function limitTo(value, length = 10) {
	const cutText = value.substring(0, length);
	return `${cutText}...`;
}


export default function (Vue) {
	Vue.filter('round', round);
	Vue.filter('limitTo', limitTo);
}



// WEBPACK FOOTER //
// ./src/filters/global.js